/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppResponseDto { 
    success?: boolean;
    message?: string | null;
    req_auth?: boolean;
    _u?: string | null;
    _t?: string | null;
    token?: string | null;
}

